<template>    
    <BaseModal
        :id="'assignments-window'"
        :title="title"
        :message="title_two"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <div class="col-12 p-0">
                <div class="w-100 table-responsive defaultproject__table overflow-y--1" v-if="assignments.length">
                    <table class="table">
                        <thead>
                            <tr>
                                <th v-for="(item, i) in assignment_table_headers" :key="i" scope="col" v-html="item.name"/>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in assignments" :key="i">
                                <td>
                                    <a class="bold-text" :href="`/assignment-daily-assignments/${item.decrypt_id}?from_room=${parent_id}`" v-html="item.number_assignment"/>
                                </td>
                                <td>
                                    <a class="bold-text" :href="`/assignment-daily-assignments/${item.decrypt_id}?from_room=${parent_id}`" v-html="item.description"/>
                                </td>
                                <td v-html="item.task_name"/>
                                <td v-html="item.frequency"/>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script>

import Breadcrumb   from  '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal    from  '@/components/BaseModal'

export default {

    name:   'DailyAssignmentsModal',
    props: [
        'title',
        'title_two',
        'assignment_table_headers',
        'assignments',
        'breadcrumb',
        'parent_id'
    ],

    components:{
        Breadcrumb,
        BaseModal,
    },

    data(){
        return{
        }
    },
    
}
</script>